import { put, takeLatest } from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";
import {
  createFlowAPI,
  deleteFlowAPI,
  getListActionAPI,
  getListComponentAPI,
  getListFlowAPI,
  removeComponentAPI,
  updateFlowAPI,
} from "redux/api/processBuilderAPI";
import {
  createFlow,
  deleteFlow,
  getListAction,
  getListActionSuccess,
  getListComponent,
  getListComponentSuccess,
  getListFlow,
  getListFlowSuccess,
  removeComponent,
  updateFlow,
} from "redux/slices/processBuilder";

export default function* processBuilderSaga() {
  yield takeLatest(getListFlow.type, getListFlowSaga);
  yield takeLatest(createFlow.type, createFlowSaga);
  yield takeLatest(updateFlow.type, updateFlowSaga);
  yield takeLatest(deleteFlow.type, deleteFlowSaga);
  yield takeLatest(getListComponent.type, getListComponentSaga);
  yield takeLatest(getListAction.type, getListActionSaga);
  yield takeLatest(removeComponent.type, removeComponentSaga);
}

function* getListFlowSaga(action) {
  try {
    const { data } = yield getListFlowAPI(action.payload);
    yield put(getListFlowSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
function* createFlowSaga(action) {
  try {
    yield createFlowAPI(action.payload.data);
    Notification("success", "Create flow success");
    yield put(getListFlow(action.payload.load));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* updateFlowSaga(action) {
  try {
    yield updateFlowAPI(action.payload.data);
    Notification("success", "Update flow success");
    yield put(getListFlow(action.payload.load));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* deleteFlowSaga(action) {
  try {
    yield deleteFlowAPI(action.payload.data);
    Notification("success", "Delete flow success");
    yield put(getListFlow(action.payload.load));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListComponentSaga(action) {
  try {
    const { data } = yield getListComponentAPI(action.payload);
    yield put(getListComponentSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListActionSaga(action) {
  try {
    const { data } = yield getListActionAPI(action.payload);
    yield put(getListActionSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* removeComponentSaga(action) {
  try {
    yield removeComponentAPI(action.payload.data);
    Notification("success", "Remove component success");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
